<template>
  <v-ons-page class="l-content l-document">
    <custom-toolbar backLabel="Retour">{{ $t("Mes documents") }}</custom-toolbar>

    <div class="container">
      <v-ons-button modifier="large" @click="view(6, 'NIE');">
        <i class="fas fa-id-card-alt"></i>{{ $t("Numéro d'identification d'étranger") }}<i class="fas fa-id-card-alt absoluteIcon"></i>
      </v-ons-button>
      <v-ons-button modifier="large" @click="view(10, $t('Choix de matériaux'));">
        <i class="fas fa-shopping-cart"></i>{{ $t("Mes commandes matériaux & Extra") }}<i class="fas fa-shopping-cart absoluteIcon"></i>
      </v-ons-button>
      <v-ons-button modifier="large" @click="view('order', $t('Mes fournitures'));">
        <i class="fas fa-boxes"></i>{{ $t("Mes fournitures") }}<i class="fas fa-boxes absoluteIcon"></i>
      </v-ons-button>
      <!-- <v-ons-button modifier="large" @click="view(7, 'Contrat conciergerie/location');">
        <i class="fas fa-key"></i>Contrat conciergerie/Location<i class="fas fa-key absoluteIcon"></i>
      </v-ons-button> -->
      <v-ons-button modifier="large" @click="view(3, $t('Contrats d\'achat'));">
        <i class="fas fa-file-contract"></i>{{ $t("Contrats d'achat") }}<i class="fas fa-file-contract absoluteIcon"></i>
      </v-ons-button>
    </div>
  </v-ons-page>
</template>

<script>
import DocumentsList from './DocumentsList.vue';

export default {
  data() {
    return {
      DocumentsList: DocumentsList
    };
  },
  methods: {
    view(category_id, title) {
      this.$store.commit('navigator/push', {
        extends: DocumentsList,
        data() {
          return {
            title: title,
            category_id: category_id
          };
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// Documents.vue?4949b4d6